import './welcome.css';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const Welcome = ({ hide }) => {
    const [animation, setAnimation] = useState(0);

    const animate = () => {
        setAnimation(1);
        setTimeout(() => {
            setAnimation(2);
            hide();
        }, 1575) // 75% animation timing + delay
    }
    return (
        <div className={`welcome ${animation === 2 ? "endAnim" : ""}`}>
            <h2 className="themed" style={{fontSize: 0}}>RÉMY JEUNIAUX<img draggable="false" alt="Rémy Amand - Jeuniaux" src="./assets/icon.svg"/></h2>
            <div className={`buttonContainer ${animation === 1 ? "active" : "reveal-area"}`}>
                <p><FormattedMessage id="welcomeText"/></p>
                <p className="hiddenTextForFutureIndexation"><FormattedMessage id="hiddenTextForFutureIndexation"/></p>
                <img draggable="false" className="hiddenForLoading" alt="" src="./assets/website/remyVitali.jpeg"/>
                <img draggable="false" className="hiddenForLoading" alt="" src="./assets/website/remyVitaliAmand.jpeg"/>
                <img draggable="false" className="hiddenForLoading" alt="" src="./assets/website/remyVitaliPortrait.jpeg"/>
                <img draggable="false" className="hiddenForLoading" alt="" src="./assets/website/remyVitaliFace.jpeg"/>
                <img draggable="false" className="hiddenForLoading" alt="" src="./assets/website/remyVitaliFacePhoto.jpeg"/>
                <div className="bubbles">
                    { [...Array(5)].map((e, i) => <img draggable="false" key={i}  height="35" alt="" src={ `./assets/shape${i % 3}.svg` } style={{animation: `bubbles ${3 + 1.34 * i}s infinite`, left: `${-50 + 20 * i }%`, "--top": `${200 - 30 * i }%`, animationDelay: `${1.5 + Math.random() * i}s`}}/>) }
                </div>
                <button onClick={() => animate()} className="reveal"><FormattedMessage id="welcomeButton"/></button>
            </div>
            { animation !== 0 &&
            <>
                { [...Array(4)].map((e, i) => <img draggable="false" className="bubblePop" key={i}  height="35" alt="" src={ `./assets/shape${i % 3}.svg` } style={{animation: `bubblesPop 1.1s forwards`, "--top": `${30 * i }vh`, animationDelay: `${0.6 + 0.1 * Math.random() * i }s`}}/>) }
                <div className="animationBack"/>
            </> }
        </div>
    );
}

export default Welcome;